// http://kazupon.github.io/vue-i18n/guide/lazy-loading.html
import Vue from 'vue';
import VueI18n from 'vue-i18n';
import it from './lang/it.json';
import { getLocale, getLocaleMessages } from '@v4/common/utils/locale';

Vue.use(VueI18n);

export const i18n = new VueI18n({
    locale: 'it', // set locale
    fallbackLocale: 'it',
    messages: { it }, // set locale messages
});

const loadedLanguages = ['it']; // our default language that is preloaded

export const setI18nLanguage = (lang) => {
    i18n.locale = lang;
    return lang;
};

export const setLanguage = (lang, msgs) => {
    i18n.setLocaleMessage(lang, msgs);
    loadedLanguages.push(lang);
    return setI18nLanguage(lang);
};

export const loadLanguageAsync = (lang) => {
    if (i18n.locale !== lang) {
        if (!loadedLanguages.includes(lang)) {
            const messages = getLocaleMessages();
            if (messages) {
                return setLanguage(lang, messages);
            } else {
                return (
                    import(/* webpackChunkName: "lang-[request]" */ `@v4/locale/lang/${lang}`)
                        .then((msgs) => setLanguage(lang, msgs))
                        // Missing locale chunk must not break the app: fall back to the default language.
                        .catch(() => setI18nLanguage(i18n.fallbackLocale))
                );
            }
        }
        return Promise.resolve(setI18nLanguage(lang));
    }
    return Promise.resolve(lang);
};

export const loadDefaultLanguage = () => loadLanguageAsync(getLocale());
